/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockElementOptions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Element Option Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 12:12:31 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const ELEMENTOPTION_LIST_CONTAINER_LOADED = 'ELEMENTOPTION_LIST_CONTAINER_LOADED';
export const ELEMENTOPTION_LIST_CONTAINER_UNLOADED = 'ELEMENTOPTION_LIST_CONTAINER_UNLOADED';
export const ELEMENTOPTION_LIST_TABLE_LOADED = 'ELEMENTOPTION_LIST_TABLE_LOADED';
export const ELEMENTOPTION_LIST_TABLE_UNLOADED = 'ELEMENTOPTION_LIST_TABLE_UNLOADED';

export const ELEMENTOPTION_SELECT_ROW = 'ELEMENTOPTION_SELECT_ROW';

export const ELEMENTOPTION_ADD = 'ELEMENTOPTION_ADD';
export const ELEMENTOPTION_EDIT = 'ELEMENTOPTION_EDIT';
export const ELEMENTOPTION_DELETE = 'ELEMENTOPTION_DELETE';
export const ELEMENTOPTION_OPEN_WARNING = 'ELEMENTOPTION_OPEN_WARNING';
export const ELEMENTOPTION_CLOSE_WARNING = 'ELEMENTOPTION_CLOSE_WARNING';

export const ELEMENTOPTION_EDIT_CONTAINER_LOADED = 'ELEMENTOPTION_EDIT_CONTAINER_LOADED';
export const ELEMENTOPTION_EDIT_CONTAINER_UNLOADED = 'ELEMENTOPTION_EDIT_CONTAINER_UNLOADED';
export const ELEMENTOPTION_EDIT_FORM_LOADED = 'ELEMENTOPTION_EDIT_FORM_LOADED';
export const ELEMENTOPTION_EDIT_FORM_UNLOADED = 'ELEMENTOPTION_EDIT_FORM_UNLOADED';

export const ELEMENTOPTION_EDIT_DATA_LOAD = 'ELEMENTOPTION_EDIT_DATA_LOAD';

export const ELEMENTOPTION_EDIT_CONTAINER_SUBMIT = 'ELEMENTOPTION_EDIT_CONTAINER_SUBMIT';
export const ELEMENTOPTION_EDIT_CONTAINER_CANCEL = 'ELEMENTOPTION_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockElementOptions.js